$(() => {
  // headerBar
  // $('.mobile-icon').on('click', (event: Event) => {
  //   if (!$(event.currentTarget).hasClass('click')) {
  //     $(event.currentTarget).addClass('click');
  //     $('.mobile-item').addClass('open');
  //     $('body').css('overflow-y', 'hidden');
  //   } else {
  //     $(event.currentTarget).removeClass('click');
  //     $('.mobile-item').removeClass('open');
  //     $('body').css('overflow-y', 'auto');
  //   }
  // });
  //
  // $('.mobile-menu-bg').on('click', () => {
  //   $('.mobile-icon').removeClass('click');
  //   $('.mobile-item').removeClass('open');
  //   $('body').css('overflow-y', 'auto');
  // });

  // top 往上移動
  $(document).on('click', '.top-button', () => {
    // console.log('hello');
    const $body = window.opera
      ? document.compatMode == 'CSS1Compat'
        ? $('html')
        : $('body')
      : $('html,body');
    $body.animate(
      {
        scrollTop: 0, // $('header').offset().top
      },
      1200,
    );

    return false;
  });
  // top 出現
  $(window).on('scroll', () => {
    const topScroll = $(document).scrollTop();
    if (topScroll > 0) {
      $('.top-button').show();
    } else {
      $('.top-button').hide();
    }
  });

  // if ($(window).width() > 768) {
  // 懸浮清單
  // $('.profile-photo').on('mouseenter', () => {
  //   $('.float-menu').show();
  // });
  // $('.float-menu, .photobox').on('mouseleave', () => {
  //   $('.float-menu').hide();
  // });
  // // 預覽課程購物車
  // $('.header-coursecartbox').on('mouseover', () => {
  //   //即時更新
  //   $('#preCourseCart').load(location.href + ' #preCourseCart >*');
  //   $('.preCourseCart').show();
  // });
  // $('.header-coursecartbox, .preCourseCart').on(
  //   'mouseleave',
  //   () => {
  //     $('.preCourseCart').hide();
  //   },
  // );
  // // 預覽產品購物車
  // $('.headerCartBox').on('mouseover', () => {
  //   //即時更新
  //   $('#preCart').load(location.href + ' #preCart >*');
  //   $('.preCart').show();
  // });
  // $('.headerCartBox, .preCart').on('mouseleave', () => {
  //   $('.preCart').hide();
  // });
  // }

  // 搜尋
  // $('.searchBtn').on('click', () => {
  //   $('.searchBtn').hide();
  //   $('.searchForm').addClass('open');
  //   $('.searchClose').show();
  //   $(
  //     '.notificationbox, .photobox, .headerCartBox, .header-coursecartbox, .mapBtn, .mobile-icon, .header-logo',
  //   ).hide();
  // });

  // $('.searchClose').on('click', () => {
  //   $('.searchBtn').show();
  //   $('.searchForm').removeClass('open');
  //   $(
  //     '.notificationbox, .photobox, .headerCartBox, .header-coursecartbox, .mapBtn, .mobile-icon, .header-logo',
  //   ).show();
  // });
});
